import { all, fork } from "redux-saga/effects";

import { watchAuth, watchUsers } from "./user";
import { watchPosts } from "./post";

export default function* rootSaga() {
  yield all([fork(watchAuth), fork(watchUsers), fork(watchPosts)]);
}
